// Core routes - common for all logged in users (RoutesCoreApp)
import React from "react"
import { Navigate, Route } from "react-router-dom"
import {
	LazyAddInvoice,
	LazyAddMessage,
	LazyAddPayment,
	LazyBusinessSettingsPage,
	LazyCase,
	LazyDialog,
	LazyDocumentUploadCard,
	LazyGlobalSettingsPage,
	LazyNotificationCenter,
	LazyHelpCenter,
	LazyMessage,
	LazyMessages,
	LazyPersonalSettingsPage,
	LazyProductSettingsPage,
	LazyProfile,
	LazySSOTestComplete,
	LazyUploadDocumentsBanner,
} from "./heavyRouteChunks"

export const BILLING_HISTORY_PATH = "/product-settings/billing-history"
export const PRODUCT_SETTINGS_APPLICATIONS_PATH = "/product-settings/applications"
export const PRODUCT_SETTINGS_PLANS_AND_USAGE_PATH = "/product-settings/plans-and-usage"
export const PRODUCT_SETTINGS_PAYMENTS_PATH = "/product-settings/payments"

export function isBillingSidebarActive(pathname) {
	return (
		pathname.startsWith(BILLING_HISTORY_PATH) ||
		pathname.startsWith(PRODUCT_SETTINGS_PLANS_AND_USAGE_PATH) ||
		pathname.startsWith(PRODUCT_SETTINGS_PAYMENTS_PATH) ||
		pathname.startsWith("/billing")
	)
}

/**
 * Get core routes (RoutesCoreApp equivalent)
 * These routes are available for all logged in users across all projects
 * @returns {JSX.Element} React fragment with routes
 */
export const getCoreRoutes = () => {
	return (
		<>
			<Route
				path='/profile'
				element={<LazyProfile />}
			/>
			<Route
				path='/billing'
				element={<Navigate to={BILLING_HISTORY_PATH} replace />}
			/>
			<Route
				path='/billing/add-payment'
				element={<LazyAddPayment />}
			/>
			<Route
				path='/billing/add-invoice'
				element={<LazyAddInvoice />}
			/>
			<Route
				path='/messages'
				element={<LazyMessages />}
			/>
			<Route
				path='/messages/add'
				element={<LazyAddMessage />}
			/>
			<Route
				path='/messages/:messageId'
				element={<LazyMessage />}
			/>
			<Route
				path='/upload-documents/:messageId'
				element={<LazyUploadDocumentsBanner />}
			/>
			<Route
				path='/upload-documents/:messageId/upload'
				element={<LazyDocumentUploadCard />}
			/>
			<Route
				path='/help'
				element={<LazyHelpCenter />}
			/>
			<Route
				path='/help/messenger/:dialogId'
				element={<LazyDialog />}
			/>
			<Route
				path='/help/messenger/case'
				element={<LazyCase />}
			/>
			<Route
				path='/profile/sso_complete'
				element={<LazySSOTestComplete />}
			/>
			<Route
				path='/personal-settings'
				element={<LazyPersonalSettingsPage />}
			/>
			<Route
				path='/business-settings'
				element={<LazyBusinessSettingsPage />}
			/>
			<Route
				path='/global-settings'
				element={<LazyGlobalSettingsPage />}
			/>
			<Route
				path='/notification-center'
				element={<LazyNotificationCenter />}
			/>
			<Route
				path={PRODUCT_SETTINGS_APPLICATIONS_PATH}
				element={<LazyProductSettingsPage />}
			/>
			<Route
				path={BILLING_HISTORY_PATH}
				element={<LazyProductSettingsPage />}
			/>
			<Route
				path={PRODUCT_SETTINGS_PLANS_AND_USAGE_PATH}
				element={<LazyProductSettingsPage />}
			/>
			<Route
				path={PRODUCT_SETTINGS_PAYMENTS_PATH}
				element={<LazyProductSettingsPage />}
			/>
		</>
	)
}
